import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BuildIcon from '../../assets/icons/build';
import CalendarIcon from '../../assets/icons/calendar';
import Linkedin from '../../assets/icons/linkedin';
import LocationIcon from '../../assets/icons/location';
import WorkIcon from '../../assets/icons/work';
import { WORK_SCHEDULE } from '../../config/consts';
import Button from '../Button';
import classes from './style.module.scss';

export default function JobCardContent({
  title,
  location,
  date,
  team,
  workSchedules,
  linkedinUrl,
  kariyerUrl,
  applyUrl,
  onClickLinkedin,
  onClickKariyer,
  onClickApplyJob
}) {
  const { t } = useTranslation();

  const handleClickLinkedin = () => {
    onClickLinkedin(linkedinUrl);
  };

  const handleClickKariyer = () => {
    onClickKariyer(kariyerUrl);
  };

  const handleClickApplyJob = () => {
    onClickApplyJob(applyUrl);
  };

  return (
    <div className={classes.jobCardContainer}>
      <div className={classes.leftContainer}>
        <div className={classes.logoIcon}>
          <img src="/assets/short-logo.png" alt={title} />
        </div>
        <div className={classes.jobContent}>
          <div className={classes.job}>{title}</div>
          <div className={classes.jobDetail}>
            <div>
              <div>
                <div className={classes.icon}>
                  <BuildIcon />
                </div>
                <div className={classes.text}>{team}</div>
              </div>
              <div>
                <div className={classes.icon}>
                  <LocationIcon h={16} w={16} />
                </div>
                <div className={classes.text}>{location}</div>
              </div>
            </div>
            <div>
              <div>
                <div className={classes.icon}>
                  <WorkIcon h={16} w={16} />
                </div>
                <div className={classes.text}>
                  {WORK_SCHEDULE(t)[workSchedules]}
                </div>
              </div>
              <div>
                <div className={classes.icon}>
                  <CalendarIcon />
                </div>
                <div className={classes.text}>
                  {dayjs(date).format('DD MMM')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.rightContainer}>
        {linkedinUrl && (
          <Button onClick={handleClickLinkedin}>
            <div className={classes.icon}>
              <Linkedin />
            </div>
            <div>{t('job_apply_linkedin')}</div>
          </Button>
        )}
        {!linkedinUrl && kariyerUrl && (
          <Button onClick={handleClickKariyer}>
            <div>{t('job_apply_kariyer')}</div>
          </Button>
        )}
        {applyUrl && (
          <Button onClick={handleClickApplyJob}>
            <div>{t('job_apply')}</div>
          </Button>
        )}
      </div>
    </div>
  );
}

JobCardContent.propTypes = {
  title: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  team: PropTypes.string.isRequired,
  workSchedules: PropTypes.string.isRequired,
  linkedinUrl: PropTypes.string,
  kariyerUrl: PropTypes.string,
  applyUrl: PropTypes.string.isRequired,
  onClickLinkedin: PropTypes.func.isRequired,
  onClickKariyer: PropTypes.func.isRequired,
  onClickApplyJob: PropTypes.func.isRequired
};

JobCardContent.defaultProps = {
  linkedinUrl: '',
  kariyerUrl: ''
};
